export default {
  "enquiry-email": "info@gopopin.co.uk",
  "landing-page": {
    "enquire-about-dark": "Enquire about",
    "enquire-about-light-1": "joining",
    "enquire-about-light-2": "Popin",
    "card-1-title": "Tools to drive footfall",
    "card-1-description":
      "Customisable and easy to use direct marketing capabilities. No digital marketing experience required. Power tools enabling full flexibility as to how and when to reach target customers in order to create awareness and stimulate demand exactly when and how you want it.",
    "card-2-title": "Retain customers",
    "card-2-description":
      "Customisable and engaging loyalty mechanics which encourage customers to digitally check in on every visit. Unique fun, approachable and gamified approach drives up frequency of visits and creates customers who feel rewarded for loyalty.",
    "card-3-title": "Closer engagement",
    "card-3-description":
      "Digital tools that enable you to communicate directly with customers in a really easy way, know who your best customers are and track your businesses performance with your customers in real-time. All in order to deliver the best digitally-led customer satisfaction.",
    enquire: "Enquire",
    "i-have-an-account": "I have an account.",
    login: "Login",
    signin: "Sign in",
    "engage-with-customer": "Engage with your customers digitally with",
    "engage-with-customer-text":
      "The platform to help local destinations connect better with their customers.",
    "keep-in-touch-text": "Keep in touch with your customers",
    "enquire-now": "Enquire now",
    "terms-service": "Terms or service",
    "privacy-policy": "Privacy Policy",
    "sign-in-confirm": "By signing in to this app, you agree to our",
    "term-privacy": " Term & Privacy Policy",
  },
  "signup-step-1": {
    header: "Create account",
    "step-1-of-3": "Step 1 of 3",
    "business-type-header": "Choose your business type:",
    "business-type-subheader": "Business type:",
    "business-type-combobox-default": "Select type",
    "business-type-error": "Please select business type",
    "main-aim-header": "Choose your main aim:",
    "main-aim-error": "Please select your main aim",
    "next-step": "Next Step",
    back: "Back",
  },
  "signup-step-2": {
    header: "Create account",
    subheader: "Set up business profile",
    "step-2-of-3": "Step 2 of 3",
    "business-name-header": "Business name",
    "business-name-combobox-default": "Enter business name",
    "business-name-error": "Please enter business name",
    "postcode-header": "Postcode",
    "address-header": "Address",
    "postcode-combobox-default": "Enter postcode",
    "postcode-error": "Please enter a postcode",
    "address-placeholder": "Enter address",
    "address-error": "Please enter an address",
    "location-header": "Select location:",
    "location-error": "Please select a location",
    "next-step-no-login-data": "Next Step",
    "next-step-with-login-data": "Continue",
    back: "Back",
  },
  "signup-step-3": {
    header: "Create account",
    subheader: "Let's complete your profile",
    "step-3-of-3": "Step 3 of 3",
    "email-header": "Email:",
    "fullname-header": "Full name",
    "email-default": "Enter email",
    "fullname-default": "Enter full name",
    "email-error": "Please enter a valid email",
    "password-header": "Password",
    "password-default": "Enter password",
    "password-error": "Please enter a password",
    "fullname-error": "Please enter a fullname",
    "password-repeat-header": "Repeat password",
    "password-repeat-error": "Passwords do not match",
    "captcha-error": "Please verify Captcha",
    "next-step": "Next Step",
    back: "Back",
  },
  "signup-step-4": {
    header: "Thank you for registering",
    "will-contact-soon": "One of our team members will contact you shortly.",
    "in-the-meantime-1": "In the meantime feel free to drop us a line",
    "in-the-meantime-2": "anytime at",
    login: "Login",
  },
  system: {
    noRecord: "No Record",
    yourRecord: "Your Records",
    busiestDate: "Busiest date",
    visits: "Visits",
    mostViewed: "Most viewed",
    mostPinned: "Most pinned",
    mostRedemptions: "Most redemptions",
  },
  dashboard: {
    "post-views": "Post views",
    "post-likes": "Post likes",
    loyaltyReward: "Active rewards",
    activePost: "Active posts",
    activeEvents: "Active events",
    noActiveEvents: "No active events",
    avgCustomerRating: "Av. Customer Rating (last 7 days)",
    followers: "Followers",
    sinceLastWeek: "Since last week",
    noActiveLoyaltyWarning: "You have no loyalty rewards currently active for your customers!",
    "loyalty-checkins": "Checkins",
    heading: "Dashboard",
    "edit-button-text": "Edit",
    "num-followers-total": (count) => {
      if (count === undefined) {
        // Happens briefly on refresh
        return "... followers";
      } else if (count === 0) {
        return "No followers";
      } else if (count === 1) {
        return "1 follower";
      } else {
        return `${count} followers`;
      }
    },
    "num-followers-this-week": (count) => countDiffThisWeek(count),
    "live-posts": {
      heading: "Live posts",
      "view-all": "View all",
      "title-column-header": "Title",
      "description-column-header": "Description",
      "time-left-column-header": "Expires",
      "actions-column-header": "Actions",
      "edit-post": "Edit post",
      "end-post": "End post",
    },
    summary: {
      heading: "Summary",
      "live-posts": "Live posts",
      "total-posts": "Total number of posts",
      "num-customers": "Number of customers",
      "views-per-post": "Views per post",
      "likes-per-post": "Likes per post",
      "total-rewards-claimed": "Total rewards claimed",
      "weekly-rewards-claimed": "Weekly rewards claimed",
      "diff-this-week": (count) => countDiffThisWeek(count),
      "percent-this-week": (percentage) => percentThisWeek(percentage),
    },
    "team-members": {
      heading: "Team members",
      "invite-button": "+ Invite",
      "no-team-members": "No team members",
      online: "online",
      "send-message": "Send message",
      "delete-user": "Delete user",
      "invite-modal": {
        heading: "Invite member to your team",
        "email-heading": "Email",
        "email-placeholder": "Enter email",
        "allow-messaging": "Allow messaging feature",
        "send-invite": "Send invite",
      },
    },
    "edit-modal": {
      heading: "Edit business",
      "drag-and-drop-1": "Drag and drop an image",
      "drag-and-drop-2": "or",
      "browse-files": "browse",
      title: "Title",
      "title-placeholder": "Enter title",
      description: "Description (Max 120 characters)",
      shortDescription: "Short description (Max 60 characters)",
      "create-post": "Create Post",
      "edit-post": "Edit Post",
      "re-post": "Re Post",
      "review-btn": "Review",
      "post-btn": "Post",
      "save-btn": "Save",
      "cancel-btn": "Cancel",
      "description-placeholder": "Enter description",
      "title-empty-error": "The title cannot be empty",
      "image-empty-error": "The image can not empty",
      "title-too-long-error": (maxLength) =>
        `The title may not be more than ${maxLength} characters`,
      "description-empty-error": "The description cannot be empty",
      "description-too-long-error": (maxLength) =>
        `The description may not be more than ${maxLength} characters`,
    },
  },
  "review-post-modal": {
    "review-post": "Review before submit",
    "btn-back": "Back",
    "btn-post": "Post",
  },
  "post-modal": {
    "create-new-post": "Create New Post",
    "drag-and-drop-1": "Drag and drop an image",
    "drag-and-drop-2": "or",
    "browse-files": "browse",
    title: "Title",
    "title-placeholder": "Enter title",
    description: "Description",
    "edit-post": "Edit Post",
    "end-post": "End post",
    "post-btn": "Post",
    "cancel-btn": "Cancel",
    "description-placeholder": "Enter description",
    "expire-post-date-time-placeholder": "Expiry Time",
    "schedule-post": "Schedule Post Time",
  },
  location: {
    "you-are-here": "You are here",
  },
  "loyalty-chart": {
    "total-feedback": "Total feedback",
    statistics: "Statistics",
  },
  "reward-modal": {
    name: "Name:",
    nickname: "Nickname:",
    id: "ID:",
    "visit-number": "Visit number:",
    reward: "Reward:",
    confirm: "Confirm",
  },
  "contact-modal": {
    heading: "Send us a message",
    topic: "Topic",
    message: "Message",
    "topic-placeholder": "Enter Topic",
    "message-placeholder": "Enter Message",
    "cancel-btn": "Cancel",
    "send-btn": "Send",
  },
  toasts: {
    authorization: "Authorization",
    "session-expired": "Your session has expired. Please login again.",
  },
  general: {
    dateRange: "Date range",
    today: "Today",
    yesterday: "Yesterday",
    thisWeek: "This week",
    lastWeek: "Last week",
    thisMonth: "This month",
    thisYear: "This year",
    allTimes: "All Times",
    last12m: "Last 12m",
    last30Days: "Last 30 days",
    last7days: "Last 7 days",
    positive: "Positive",
    negative: "Negative",
    reviewsWithValue: "{{value}} reviews",
    stars: "{{value}} stars",
    visits: "Visits",
    visitsWithValue: "{{value}} visits",
    male: "Male",
    female: "Female",
    other: "Other",
    gender: "Gender",
    all: "All",
    totalVisits: "Total visits",
    green: "Green",
    age: "Age",
    silver: "Silver",
    gold: "Gold",
    customer: "Customer",
    rank: "Rank",
    viewAll: "View all",
    allCustomers: "All customers",
    allRatings: "All Ratings",
    sortBy: "Sort by",
    tier: "Tier",
    visit: "Visit",
    interest: "Interest",
    claim: "Claim",
    redeem: "Redeem",
    joinedDate: "Joined Date",
    lastVisit: "Last Visit",
    newest: "Newest",
    oldest: "Oldest",
    postView: "Post views",
    checkIns: "Check-ins",
    interested: "Pinned",
    redemptions: "Redemptions",
    followers: "Followers",
    demographic: "Demographic",
    emptyRecord:
      "Oops, you haven't posted anything yet. Start creating posts to track their stats over time.",
    noInformation: "No information",
    lessThanNb: "Less than 10 left",

    noLoyaltyProgram: "You don't have a loyalty program yet. Contact Popin to set up.",
  },
  placeholder: {
    searchCustomerNameOrUsername: "Search customer name or username...",
  },
  "navigation-titles": {
    dashboard: "Dashboard",
    checkins: "Checkins",
    posts: "Posts",
    loyalty: "Rewards Tracker",
    rewards: "Rewards Tracker",
    events: "Events Tracker",
    messages: "Messages",
    schedule: "Schedule",
    settings: "Profile & Settings",
    template: "Templates",
    images: "Image gallery",
    business: "Business profile",
    user: "User profile & Settings",
    ratings: "Ratings",
    customers: "Customer Insights",
    profile: "Profile and settings",
    imageGallery: "Image gallery",
    vendors: "Vendors",
  },
  "image-gallery": {
    manageCategory: "Manage Category",
    addImage: "Add image",
    viewImage: "View image",
    category: "Category",
    addCategory: "Add category",
    updateCategory: "Update category",
    photos: "photos",
    categoryName: "Category name",
    categoryNamePlaceholder: "Enter category name",
    deleteCategory: 'Delete "{CATEGORY_NAME}"',
    deleteImage: "Delete image?",
    confirmDelteCategory: 'All photos in "{CATEGORY_NAME}" will be moved to Uncategorized',
    confirmDeleteImg: "Are you sure you want to delete this image?",
    addedBy: "Added by",
    imageCategory: "Image category",
    addNumberImages: "Add {{total}} image(s)",
    all: "All",
    unCategorized: "Uncategorized",
    addCategorySuccess: "Add category successfully",
    updateCategorySuccess: "Update category successfully",
    deleteCategorySuccess: "Delete category successfully",
    updateImageCategorySuccess: "Image category updated.",
    recent: "Recent",
    deleteImageSuccess: "Delete image successfully",
  },
  "manage-post": {
    newPost: "New Post",
    editPost: "Edit Post",
    select: "Select",
    optimize: "Optimise",
    limit: "Limit",
    done: "Done",
    review: "Review",
    selectTemplate: "Select Template",
    customizeTemplate: "Customise Template",
    setTimeLimits: "Set Time Limits",
    reviewSchedule: "Review & Schedule",
    changeImage: "Change image",
    title: "Title",
    enterTitle: "Enter post's title",
    description: "Description",
    enterDescription: "Enter post's description",
    postType: "Post type",
    availableFor: "Available for",
    reservation: "Reservation",
    noAvailable: "No. Available",
    loyaltyRewards: "Rewards",
    awareness: "Awareness",
    event: "Event",
    promotion: "Promotion",
    loyalty: "Loyalty",
    pending: "Approval pending",
    all: "All",
    required: "Required",
    optional: "Optional",
    chooseImage: "Choose image from library",
    redemptionValidity: "Reward Live",
    postLive: "Post Live",
    eventLiveDuration: "Event Live Duration",
    repeat: "Repeat",
    from: "From",
    to: "To",
    now: "Now",
    no: "No",
    noTimeLimit: "No time limit",
    every: "Every",
    weeks: "week(s)",
    noRepeat: "No repeat",
    everyRepeat: "Every {{repeatTime}} week(s)",
    claim: "Claim",
    postScheduled: "Post scheduled!",
    postScheduledDesc: "Successfully scheduled post. \n You can view and edit in Post List",
    postedBy: "Posted by",
    preview: "Preview",
    pleaseSelectTemplate: "Please select a template",
    termsAndConditions: "Terms and Conditions",
    confirmEndPost: "Are you sure you want to end this post?",
    deletePost: "Delete post ?",
    confirmDeletePost: "Are you sure you want to delete this post?",
    staffWarning: "Only manager users can approve/reject pending posts",
    approve: "Approve Post",
    reject: "Reject Post",
    delete: "Delete Post",
    end: "End Post",
    edit: "Edit Post",
  },

  "user-profile": {
    edit: "Edit",
    changePassword: "Change password",

    settings: "Settings",
    activity: "Activity",

    notification: "Notification",
    notificationDes:
      "Turn on events you want to receive notification. We'll send you an update email.",
    permission: "Permissions",
    permissionDes: "Enable Team Member permissions",
    // guide: "Guide",
    // enableGuide: "Enable guide",
    needHelp: "Need help?",
    contact: "Contact us",
    policy: "Read our policies",

    activityPost: "Posts activity",
    activityClaim: "Claims activity",
    activityRating: "Ratings activity",

    permissionOptimize: "Optimize post",
    permissionSchedule: "Schedule post without review",
    permissionUploadImage: "Update image gallery",
    permissionUpdateBusiness: "Update business profile",

    editPersonalInfo: "Edit personal info",
    editPersonalInfoNotifySuccess: "Personal info updated successfully!",
    cancel: "Cancel",
    save: "Save",
    uploadPhoto: "Upload photo",
    uploadDescription: "Photo must be PNG, JPG or JPEG and less than 2MB",

    newPassword: "New password",
    newPasswordTextPlaceholder: "Please enter your new password",
    confirmNewPassword: "Confirm new password",
    confirmNewPasswordTextPlaceholder: "Please confirm your new password",

    updatePasswordSuccessfully: "Updated password successfully !",
    errorNotificationPasswordIncorrect:
      "The password is invalid or the user does not have a password.",
    email: "Email",
    emailPlaceholder: "Please enter your email",
    fullName: "Full name",
    fullNamePlaceholder: "Please enter your full name",
  },

  "view-post": {
    viewPost: "View post",
    view: "View",
    interest: "Interest",
    claim: "Claim",
    redeem: "Redeem",
    yes: "Yes",
    no: "No",
    validity: "Validity",
    postId: "Post ID:",
  },
  tiers: {
    tiersMember: "{{tier}} Member",
    tiersMemberReward: "{{tier}} Reward",
    followerReward: "loyaltyMemberReward",
    excitingNews: "Exciting News",
    follower: "Follower",
    bronze: "Bronze",
    silver: "Silver",
    loyaltyMember: "Loyalty Club",
    needVisits: "Required Visits",
    inActiveDate: "Inactive Days",
    points: "Points",
    manageTier: "Manage Tier",
    editTier: "Edit Tier",
    addTier: "Add Tier",
    deleteTier: "Delete Tier",
    tierLevel: "Tier Level",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
  },
  loyaltyRewards: {
    summary: "Loyalty Milestones",
    rewardsList: "Rewards List",
    changeRules: "Change rules",
    loseProgress: "Lose progress",
    ifInactiveFor: "if inactive for",
    days: "day(s)",
    visitsNeed: "Visits need",
    members: "Members",
    active: "Active",
    expired: "Expired",
    noRewards: "No rewards",
    noPosts: "No posts",
    postCode: "Post ID",
    id: "ID",
    claimed: "Claimed",
    redeemed: "Redeemed",
    expiredTime: "Expired time",
    viewReward: "Claim reward",
    viewPost: "View post",
  },
  events: {
    eventsList: "Events List",
    active: "Active",
    expired: "Expired",
    noEvents: "No events",
    postCode: "Post ID",
    startDate: "Start date",
    endDate: "End date",
    views: "Views",
  },
  changeRules: {
    changeRules: "Request Change",
    tierName: "Tier name",
    anyChangesNeedApprove: "Any changes made require approval by a Popin Admin",
    staffWarning: "Staff users cannot change rules",
    addTier: "Add tier",
    noticed:
      "First time loyalty program setup will be automatically saved. However, any subsequent changes made by vendors will require approval by a Popin Admin",
  },
  "reward-detail": {
    rewardDetail: "Reward detail",
    customer: "Customer",
    claim: "Claim",
    claimDate: "Claim Date",
    redeem: "Redeem",
    redeemDate: "Redeem Date",
  },
  checkins: {
    heading: "Customer verification",
    "generate-qr-code": "Generate QR code",
    "provide-1": "Provide this QR code",
    "provide-2": "to the consumer",
  },
  forgotPasswords: {
    "forgot-password": "Forgot Password",
    "email-placeholder": "Email address",
    "email-req-error": "email field is required",
    "reset-password-btn": "Reset",
  },
  posts: {
    heading: "Posts",
    subheading: "Expired Posts",
    archiveheading: "Archive Posts",
    "new-post-btn": "New Post",
    "change-post": "Change Post",
    "extend-post": "Exend Post",
    "end-post": "End Post",
    "delete-post": "Delete Post",
    "edit-post": "Edit post",
    "approve-post": "Approval Post",
    "reject-post": "Reject Post",
    "archive-post": "Archive Post",
    "re-post": "Re Post",
    "no-available-post": "No Live Posts",
    "no-expire-post": "No Expired Posts",
    "no-archive-post": "No Archive Posts",
  },
  "error-page": {
    heading: "Page Not Found 🕵🏻‍♀️",
    subheading: "Oops! 😖 The requested URL was not found on this server.",
    "back-to-home": "Back to home",
  },
  login: {
    heading: "Log in to Popin",
    "google-prompt": "Log in with Google",
    "facebook-prompt": "Log in with Facebook",
    or: "Or",
    login: "Sign in",
    email: "Email",
    "email-placeholder": "Enter your email",
    password: "Password",
    "password-placeholder": "Enter your password",
    "email-error": "Please enter a valid email",
    "password-error": "Please enter your password",
    "forgot-password": "Forgot password",
    "no-account": "I don't have an account.",
    remember: "Remember me",
    forgot: "Forgot password",
    termInfoLabel: "By signing in you agree to our",
    terms: "Terms & Privacy Policy",
    noAccountLabel: "I don't have an account. ",
    success: "Logged in successfully",
    "multiple-roles":
      "You have multiple active roles. For now, only your first role is accessible. Please contact Popin for more details.",
    "success-facebook": "Logged in successfully with Facebook",
    "success-google": "Logged in successfully with Google",
    "failure-invalid": "Email or Password is not correct",
    "failure-user-not-business": "This website is for business users only.",
    "account-not-activated": "Your account is not activated yet, contact your manager.",
  },
  invitation: {
    heading: "Hi, welcome",
    join: "Join",

    confirmPassword: "Confirm password",
    confirmPasswordPlaceholder: "Retype your password",

    expiredInvitation: "Your invitation is expired !",
    expiredInvitationForm: {
      title: "The link expired",
      descriptionOne: "Your invitation has expired. Please ask your manager to send a new one.",
      descriptionTwo: "If you keep experiencing this issue please contact",
      emailContact: "support@popin.social",
    },
  },
  signUp: {
    heading: "Sign up",
    back: "Back",
    next: "Next",
    createAccountHeader: "Create an account",
    chooseBusiness: "Choose your business type",
    businessCategory: "Business category",
    businessCategoryPlaceholder: "Select business category",
    businessCategoryErrorText: "Business category is required",
    businessSubCategory: "Business sub-category",
    businessSubCategoryPlaceholder: "Select sub-category",
    businessSubCategoryErrorText: "Business sub-category is required",
    passwordText: "Your password",
    passwordTextPlaceholder: "Enter password",
    passwordRequiredText: "Please enter your password",
    aimingCheckboxHeader: "What is your main aim(s)?",
    aimingRequiredText: "Please check your main aims(s)",
    setupProfile: "Set up business profile",
    name: "Your name",
    namePlaceholder: "Enter full name",
    nameRequiredText: "Please fill your full name",
    businessName: "Business name",
    businessNamePlaceholder: "Enter business name",
    businessNameRequiredText: "Please fill your business name",
    postcode: "Postcode",
    postcodePlaceholder: "Enter postcode",
    postcodeRequiredText: "Please enter your postcode",
    email: "Email address",
    emailPlaceholder: "Enter email address",
    emailRequiredText: "Please enter your email",
    thank: "Thank you for registering!",
    contact: "One of our team will contact you shortly",
    question: "If you have any questions in the meantime please email us at",
    emailContact: "info@popin.social",
  },
  schedule: {
    showText: "Show guide",
    hideText: "Hide guide",
    effectiveIntroduction: "How to Master Your Effectiveness",
    setPostIntroduction: "How to Schedule a Post",
    postGuideSelect: "Select",
    postGuideSelectDes: "Select a template",
    postGuideOptimize: "Optimise",
    postGuideOptimizeDes: "Customise template",
    postGuideLimit: "Limit",
    postGuideLimitDes: "Set time limits",
    postGuideDone: "Done",
    postGuideDoneDes: "Review and schedule post",

    chartOverview: "Schedule Overview",
    chartDescription: "This calendar shows all of your scheduled posts",
    livePosts: "Live posts",
    upcomingPosts: "Upcoming posts",
    awareness: "Awareness",
    event: "Event",
    promotion: "Promotion",
    rewards: "Rewards",
    all: "All",

    suggestLive: "Suggest Live count:",
    awarenessDescription: "(optional): Max 1-2",
    eventDescription: "(optional): Max 1-2",
    // rewardsDescription:
    //   "(required): Should always have at least one available to Silver and Gold Members",
    rewardsDescription: "Should always have at least one available to Loyalty Members",
    noPosts: "No Posts",
    pendingPosts: "Posts Pending Manager Approval",
    allPosts: "All posts",
    postCreator: "Post creator",
    pendingReview: "Pending review",
    postView: "Post view",
    postInterest: "Post interest",
    startDate: "Start date",
    endDate: "End date",
    expired: "Expired",

    notifyDeleteSuccess: "Post deleted successfully",
    notifyEndSuccess: "Post ended successfully",

    sortedBy: "Sort by",

    thisMonth: "This month",
    thisWeek: "This week",
    thisYear: "This year",

    viewPost: "View post",
    editPost: "Edit post",
    endPost: "End post",
    deletePost: "Delete post",
    reschedule: "Reschedule",
  },
  customerInsights: {
    engagementOverview: "Engagement Overview",
    activityOverTime: "Activity over time",
    checkInsByDemographic: "Check-ins by demographic",
    topCustomers: "Top Customers",
    postViews: "Post views",
    ratings: "Ratings",
    ratingsOverTime: "Ratings over time",
    basedOnReviews: "Based on {{value}} reviews",
  },
  loyalty: {
    heading: "Loyalty",
    "setup-tiers": "Set up tiers",
    "pending-claims": "Pending claims",
    "recent-claims": "Recent claims",
    history: "History",
    "column-name": "Name",
    "column-tier": "Tier",
    "column-description": "Description",
    "column-date": "Date",
    "column-num-checkins": "Number of checkins",
    "column-num-likes": "Number of likes",
    "column-num-visits": "Number of visits",
    "column-actions": "Actions",
    "message-button": "Message",
    "column-visits-needed": "Visits needed",
    "column-inactive-time": "Inactive days",
    "column-award-title": "Award title",
    "add-tier": "+ Add Tier",
    "top-20-customers": "Top 20 customers",
    "view-all": "View all",
    cancel: "Cancel",
    apply: "Apply",
  },
  messages: {
    heading: "Messages",
    subheading: "Recent Chats",
    invite: "+ Invite",
    "search-messages": "Search by customer name",
    "no-users-found": "No Users found!",
    "start-conversations": "Start Conversations",
    you: "You",
  },
  rating: {
    heading: "Rating",
    "reviews-summary": "Reviews summary",
    "of-5": "of 5",
    "based-on": "Based on",
    feedbacks: "feedbacks",
    stars: "stars",
    "top-topics": "Top topics:",
    "this-week": "Last 7 days",
    "this-month": "Last 30 days",
    "this-year": "Last 365 days",
    votes: "votes",
    "no-topics-found": "No Topics found",
    "recent-feedback": "Recent feedback",
    "column-customer": "Customer",
    "column-visit": "Visit #",
    "column-date": "Date",
    "column-opearation": "Operation",
    "column-provider": "Provider",
    "column-rate": "Rate",
    "column-issues": "Topics",
    "column-actions": "Actions",
    message: "message",
  },
  forgotPassword: {
    title: "Forgot password",
    submit: "Send email",
    sendSuccess: "Send email successfully",
  },
  businessProfile: {
    totalFollower: "Followers",
    avgRating: "Avg. Rating",

    businessPhoto: "Profile photo",
    businessDetail: "Business Details",
    businessTeam: "Team Member",
    openingHours: "Opening hours",
    contact: "Links",
    menu: "Menu",

    member: "member",
    role: "role",
    rolePlaceholder: "Enter role",
    joinedDate: "joined date",
    lastActivity: "last activity",
    promote: "Promote",
    demote: "Demote",
    remove: "Remove",

    edit: "Edit",
    requestChange: "Request change",
    activityLog: "Activity Log",
    noMoreActivity: "No more activity",
    addMember: "Add Member",
    inviteMember: "Invite member",
    editBusinessDetail: "Edit business detail",
    addProfilePhoto: "Add Profile Photo",
    sendInvitation: "Send invitation",
    invitationInfo: "Popin will send an activation email to",

    businessDescription: "Description",
    editBusinessDescription: "Edit description",
    descriptionPlaceholder: "Enter your new description",

    memberUpdatedRole: "Member role updated!",
    memberRemoved: "Member removed!",

    sameEveryday: "Same everyday",

    manager: "Manager",
    memberTitle: "Member",
    staff: "Staff",
    roleTitle: "Role",

    requiredField: "Required.",

    phone: "Phone number",
    phonePlaceholder: "Enter phone number",
    phoneRequired: "Please fill your vendor phone",
    ins: "Instagram",
    insPlaceholder: "Enter instagram account",
    insRequired: "Please fill your vendor instagram",
    email: "Email",
    emailPlaceholder: "Enter email",
    website: "Website",
    websitePlaceholder: "Enter website",
    websiteRequired: "Please fill your vendor website",
    message: "Message",
    messagePlaceholder: "Enter message",
    menuURL: "Menu URL",
    menuPlaceholder: "Enter your menu url",
    closed: "Closed",
    nfcIdPlaceholder: "Enter your vendor NFC ID",
    nfcId: "NFC ID",
    nfcRequired: "Please fill your vendor NFC ID",
    googlePlaceholder: "Enter your google URL",
    googleLink: "Google Reviews URL",
    googleRequired: "Please fill your vendor rating google URL",

    reservationURL: "Reservation URL",
  },
  profileSetting: {
    heading: "Profile & Settings",
    "log-out": "Log out",
    "edit-btn": "Edit",
    "save-btn": "Save",
    followers: "followers",
    "this.week": "this week",
    "need-help": "Need help?",
    "help-text":
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
    "contact-us": "Contact us",
    "or-read": "or Read",
    "privacy-policy": "Privacy policy",
    settings: "Settings",
    "background-images": "Background Images",
    "thumbnail-image": "Thumbnail Image",
    fullname: "Full name",
    "business-name": "Business Name",
    "business-type": "Business type",
    "business-category": "Business category",
    "business-subcategory": "Business subcategory",
    postcode: "Postcode",
    email: "Email",
    password: "Password",
    subscription: "Subscription",
    "fullname-placeholder": "Enter full name",
    "business-name-placeholder": "Enter business name",
    "postcode-placeholder": "Enter postcode",
    "email-placeholder": "Enter email",
    "password-placeholder": "Enter password",
    "upgrade-btn": "Upgrade",
    "create-profile-image": "Create profile image",
    website: "Website",
    instagram: "Instagram",
    "make-a-call": "Phone number",
    "min-spent-checkin": "Minimum money to spend for checkin",
    booking: "Booking",
    menu: "Menu",
    nfcTag: "NFC tags",
    "website-placeholder": "Enter business website",
    "instagram-placeholder": "Enter instagram",
    "make-a-call-placeholder": "Enter phone number",
    "min-spent-checkin-placeholder": "Enter minimum money to spend for checkin",
    "booking-placeholder": "Enter booking link",
    "menu-placeholder": "Enter menu link",
    "nfc-tags-placeholder": "Enter nfc tag",
  },
  data: {
    "fetch-error": "Unexpected error when fetching data",
    "unexpected-error": "Unexpected error!",
  },
  pagination: {
    total: "Total",
  },
  "sort-by": "Sort by",
  button: {
    ok: "OK",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    back: "Back",
    submit: "Submit",
    invite: "Invite",
    deactivateAccount: "Deactivate Account",
    create: "Create",
    update: "Update",
    close: "Close",
  },
  uploadImage: {
    selectFromDevice: "Select from your device",
    dragAnDropImage: "or drag and drop your images here",
    maximum: "Up to 5 photos can be selected",
  },
  manageTemplate: {
    createTemplate: "Create template",
    editTemplate: "Edit template",
    viewTemplate: "View template",
    deleteTemplate: "Delete template",
    postType: "Post type",
    setTemplateIntroduction: "How create template",
    templateGuideType: "Type",
    templateGuideTypeDes: "Choose a post type",
    templateGuidePhoto: "Photo",
    templateGuidePhotoDes: "Select a photo from your photo gallery",
    templateGuideDescription: "Description",
    templateGuideDescriptionDes: "Fill out post title and description",
    templateGuideDone: "Done",
    templateGuideDoneDes: "Review and save template",
    image: "Image",
    title: "Title",
    description: "Description",
    eventLink: "Event Link",
    eventLinkPlaceholder: "Enter event link (required, e.g., https://example.com/event)",
    exploreLink: "Explore Link",
    exploreLinkPlaceholder: "Enter explore link (required, e.g., https://example.com/explore)",
    noAvailable: "No. Available",
    reservationRequired: "Reservation required?",
    imagePlaceholder: "Select category(s)",
    internalTitlePlaceholder: "Select internal title",
    titlePlaceholder: "Enter post title",
    descriptionPlaceholder: "Enter post description",
    postPreview: "Post preview",
    selectImgFromGallery: "Select image directory to allow your staffs to choose an image from ",
    addTemplateSuccess: "Create template successfully",
    updateTemplateSuccess: "Update template successfully",
    deleteTemplateSuccess: "Delete template successfully",
    unlimited: "Unlimited",
    limited: "Limited",
    availableFor: "Available for",
    titleWillAppearHere: "Title will appear here",
    descriptionWillAppearHere: "Description will appear here...",
    noTemplates: "No templates",
    createdBy: "Created by",
    imageCategory: "Image category",
    confirmDeleteTemplate: "Are you sure you want to delete this template?",
    pleaseSelectImage: "Please select image",
    never: "Never",
    monthly: "Monthly",
    weekly: "Weekly",
    anytime: "Anytime",
    reclaimFrequency: "Reclaim Frequency",
    reclaimFrequencyDescription:
      "The frequency at which a follower can claim a reward again after they have claimed it once.",
    termsAndCondition: "Terms and Conditions",
    termsAndConditionDescription: "Choose to add terms & conditions for the reward.",
    noAvailableDescription:
      "Either allow unlimited claims of the reward or limit the number available - which you set when scheduling the post.",
    templateList: "Template list",
    internalTitle: "Internal Title",
    manageInternalTitle: "Manage Internal Title",
    addInternalTitle: "Add internal title",
  },
  postType: {
    awarenessTitle: "Awareness post",
    awarenessDescription:
      "delivers news to your followers. Eg: Launching something new for summer.",
    eventTitle: "Event post",
    eventDescription: "promotes an event to your followers. Eg: Live music this Friday at 8pm.",
    loyaltyTitle: "Follower Reward post",
    loyaltyDescription:
      "is a reward for all your followers. Eg: Escape rain with 30% off for 2 hours.",
    silverTitle: "Silver Reward post",
    silverDescription:
      "is a reward for Silver & Gold members. Eg: Free item for Silver members for spend over £100.",
    // goldTitle: "Gold Reward post",
    // goldDescription: "is a reward for Gold members. Eg: 10% off all purchases for Gold members",
    goldTitle: "loyalty Reward post",
    goldDescription: "is a reward for loyalty members. Eg: 10% off all purchases for Gold members",
  },
  "template-table": {
    id: "ID",
    postTitle: "Post Title",
    creationDate: "Creation Date",
    type: "Type",
    internalTitle: "Internal Title",
  },
  internalTitle: {
    internalTitleName: "Internal Title Name",
    internalTitleNamePlaceholder: "Enter internal title name",
    addInternalTitle: "Add internal title",
    addInternalTitleSuccess: "Add internal title successfully",
    updateInternalTitleSuccess: "Update internal title successfully",
    deleteInternalTitle: "Delete {INTERNAL_TITLE}",
    deleteWarning: "Are you sure to delete this Title?",
  },
  admin: {
    login: "Sign in",
    portal: "Admin Portal",
    loginSuccess: "Admin login successful",
    loginFailed: "Login failed",
    unauthorized: "Unauthorized access",
    dashboard: "Admin Dashboard",
    logout: "Logout",
    logoutSuccess: "Logged out successfully",
    metrics: {
      totalUsers: "Total Users",
      totalVendors: "Total Vendors",
      totalPosts: "Total Posts",
      totalCheckIns: "Total Check-ins",
      totalClaims: "Total Claims",
      activeVendors: "Active Vendors",
      inactiveVendors: "Inactive Vendors",
      activeUsers: "Active Users",
      inactiveUsers: "Inactive Users",
      activePosts: "Active Posts",
      todayNewUsers: "New Users Today",
      todayNewPosts: "New Posts Today",
      todayCheckIns: "Check-ins Today",
      todayClaims: "Claims Today",
      todayActivePosts: "Active Posts Today",
      todayNewVendors: "New Vendors Today",
      weeklyUsers: "New Users This Week",
      weeklyPosts: "New Posts This Week",
      weeklyCheckIns: "Check-ins This Week",
      weeklyClaims: "Claims This Week",
      weeklyActivePosts: "Active Posts This Week",
      dateRange: "Date Range",
    },
    users: {
      title: "Users Management",
      searchPlaceholder: "Search users...",
      searchAdminsPlaceholder: "Search admins...",
      editUser: "Edit User",
      createUser: "Create User",
      createNewUser: "Create New User",
      userCreated: "User created successfully",
      userCreatedWithPassword: "User Created Successfully",
      passwordCreatedMessage: "The user has been created with the following password:",
      passwordWarning:
        "Please save this password now. For security reasons, it will not be shown again.",
      passwordCopied: "Password copied to clipboard",

      editAdmin: "Edit Admin",
      inviteNewAdmin: "Invite New Admin",
      adminInvited: "Admin invitation sent successfully",
      createAdmin: "Create Admin",
      regularUsers: "Users",
      adminUsers: "Admins",
      email: "Email Address",
      fullName: "Full Name",
      nickName: "Username",
      invalidEmail: "Please enter a valid email",
      emailRequired: "Please enter an email",
      fullNameRequired: "Please enter a full name",
      nickNameRequired: "Please enter a username",
      adminDeactivated: "Admin deactivated successfully",
      deactivateAdminWarning: "Deactivate Admin Access",
      deactivateAdminDescription: "Are you sure you want to deactivate admin access for this user?",
    },
    tiers: {
      title: "Tiers Management",
      tiersTab: "Tiers",
      rewardsTab: "Rewards",
      modifyTier: "Modify Tier",
      editTier: "Edit Tier",
      tierLevel: "Tier Level",
      visitsNeeded: "Visits Needed",
      points: "Points",
      inactiveDays: "Inactive Days",
      status: "Status",
      actions: "Actions",
      active: "Active",
      inactive: "Inactive",
    },
    rewards: {
      editReward: "Edit Reward",
      title: "Title",
      description: "Description",
      tier: "Tier",
      code: "Code",
      claimed: "Claimed",
      endTime: "End Time",
      status: "Status",
      actions: "Actions",
      reviewed: "Reviewed",
      pending: "Pending",
    },
  },
  vendors: {
    searchPlaceholder: "Search vendors by name...",
    editVendor: "Edit Vendor",
    createVendor: "Create Vendor",
    noVendors: "No vendors found",
    title: "Vendor Management",
    businessName: "Business Name",
    email: "Email",
    emailRequired: "Please enter an email",
    invalidEmail: "Please enter a valid email",
    phone: "Phone Number",
    website: "Website",
    invalidWebsite: "Please enter a valid website URL",
    instagram: "Instagram",
    menuUrl: "Menu URL",
    invalidMenuUrl: "Please enter a valid menu URL",
    bookingUrl: "Reservation URL",
    invalidBookingUrl: "Please enter a valid booking URL",
    googleUrl: "Google Maps URL",
    googleUrlPlaceholder: "Enter Google Maps URL",
    invalidGoogleUrl: "Please enter a valid Google Maps URL",
    category: "Category",
    categoryRequired: "Please select a category",
    businessNameRequired: "Please enter a business name",
    status: "Live On Portal",
    cancel: "Cancel",
    create: "Create",
    createSuccess: "Vendor created successfully",
    deleteVendor: "Delete Vendor",
    deleteVendorWarning: "Are you sure you want to delete this vendor?",
    deleteVendorDescription:
      "This action cannot be undone. The vendor account and all associated data will be permanently archived.",
    deleteSuccess: "Vendor successfully deleted",
    appStatus: "Live On App",
    loyaltyStatus: "Loyalty Rewards",
    loyaltyEnabled: "Loyalty rewards are enabled for this vendor",
    loyaltyDisabled: "Loyalty rewards are disabled for this vendor",
    toggleLoyaltySuccess: "Loyalty status updated successfully",
  },
  loyalty: {
    disabledTitle: "Loyalty Rewards Disabled",
    disabledMessage:
      "Loyalty rewards are currently disabled for your business. Please contact an administrator to enable this feature.",
    disabledContactAdmin: "Contact Admin",
  },
  user: {
    status: "Dashboard Status",
    appStatus: "App Access",
    fullName: "Full Name",
    email: "Email",
    role: "Role",
    business: "Business",
    active: "Active",
    inactive: "Inactive",
    isActive: "Account Status",
    updated: "User updated successfully",
    deleteWarning: "Are you sure you want to delete this user?",
    deleteDescription:
      "This action cannot be undone. The user account and all associated data will be permanently archived.",
    deleteSuccess: "User successfully deleted",
    editUser: "Edit User",
    deleteUser: "Delete User",
  },
  vendorNFCs: {
    token: "NFC Token",
    tokenPlaceholder: "Enter NFC token",
    vendor: "Vendor",
    selectVendor: "Select vendor",
    createSuccess: "NFC token created successfully",
    updateSuccess: "NFC token updated successfully",
    title: "NFC Tags",
    search: "Search by token or vendor name",
    createNFC: "Create NFC Tag",
    editNFC: "Edit NFC Tag",
    dateRange: "Filter by date range",
  },
  validation: {
    required: "This field is required",
  },
  rewards: {
    title: "Title",
    description: "Description",
    code: "Code",
    endTime: "End Time",
    claimed: "Claimed",
    status: "Status",
    editReward: "Edit Reward",
    reviewed: "Reviewed",
    pending: "Pending",
    tier: "Tier",
    totalClaimed: "Total Claimed",
    updated: "Reward updated successfully",
  },
  common: {
    startDate: "Start date",
    endDate: "End date",
    export: "Export CSV",
  },
};

const countDiffThisWeek = (count) => {
  if (count === undefined) {
    // Happens briefly on refresh
    return "... this week";
  } else if (count > 0) {
    return `+${count} this week`;
  } else if (count < 0) {
    return `${count} this week`; // "-" already prepended
  } else {
    return "None this week";
  }
};

const percentThisWeek = (percentage) => {
  if (percentage < 0) {
    return `${percentage}% this week`;
  } else {
    // Zero or positive
    return `+${percentage}% this week`;
  }
};
